/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {Subscription} from '@ion/core/src/types/entities';
import {isObjectEmpty} from '@ion/core/src/utils/ObjectUtil';
import {useSubscription} from '@ion/query/src/hooks/useSubscription';
import useMessageEndpointAccess from './useMessageEndpointAccess';

/* Determines of the given subscription modules title is equals to 'CustomEndpoint' to be
able to maintain a Message Endpoint. */
const isCustomEndpoint = (subscription: Subscription, title: string): boolean => {
  return subscription?.modules?.some(val => val?.title === title) || false;
};

/**
 * Custom hook for determining if the conditions are met for a user to see the Message Endpoint section
 * when maintaining an Account.
 *
 * Current conditions:
 * 1) Must be CTC
 * 2) Must be an approved subscription id (environment.json)
 * 3) User must have access (via roles: user must have a role of FW Uploader, Calamp Support, or Customer Admin)
 */
export const useShowMessageEndpoint = (
  enabled = false,
  subscriptionId: number
): boolean => {
  const userCanUseAccountMessageEndpoint              = useMessageEndpointAccess();
  const [showMessageEndpoint, setShowMessageEndpoint] = useState<boolean>(false);
  const {subscription} = useSubscription(subscriptionId, userCanUseAccountMessageEndpoint);

  useEffect(() => {
    setShowMessageEndpoint(!isObjectEmpty(subscription) && userCanUseAccountMessageEndpoint && isCustomEndpoint(subscription, 'CustomEndpoint'));
  }, [subscription, userCanUseAccountMessageEndpoint, subscriptionId]);
  return showMessageEndpoint;
};

export default useShowMessageEndpoint;
